import axios from "axios";
import { toast } from "react-toastify";

const baseUrl =
  "https://raw.githubusercontent.com/hiiamrohit/Countries-States-Cities-database/master";

export const getCountries = () => {
  const res = axios
    .get(`${baseUrl}/countries.json`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      toast.error(err);
    });
  return res;
};

export const getStates = (id = 101) => {
  const res = axios
    .get(`${baseUrl}/states.json`)
    .then((res) => {
      const data = res.data?.states?.filter((state) => {
        return state?.country_id === id;
      });

      return data;
    })
    .catch((err) => {
      toast.error(err);
    });
  return res;
};

export const getCities = (id = 12) => {
  const res = axios
    .get(`${baseUrl}/cities.json`)
    .then((res) => {
      const data = res.data?.cities?.filter((city) => {
        return city?.state_id === id;
      });

      return data;
    })
    .catch((err) => {
      toast.error(err);
    });
  return res;
};
